module.exports = __webpack_public_path__ + "static/media/GoupMoveMemberBigIcon.23c809b3.svg";